const API_BASE = process.env.REACT_APP_API_BASE || "/api";

function getToken() {
  return localStorage.getItem("mairie_token") || "";
}

export function setToken(token) {
  if (token) localStorage.setItem("mairie_token", token);
  else localStorage.removeItem("mairie_token");
}

async function request(method, path, body, opts = {}) {
  const headers = { "Content-Type": "application/json" };
  const token = getToken();
  if (token) headers["Authorization"] = `Bearer ${token}`;

  const cfg = { method, headers, credentials: "include", ...opts };
  if (body !== undefined) cfg.body = JSON.stringify(body);

  const res = await fetch(`${API_BASE}${path}`, cfg);
  const text = await res.text();
  let data = null;
  try { data = text ? JSON.parse(text) : null; } catch { data = text; }

  if (!res.ok) {
    const detail = (data && data.detail) || res.statusText;
    const err = new Error(typeof detail === "string" ? detail : JSON.stringify(detail));
    err.status = res.status;
    err.data = data;
    throw err;
  }
  return data;
}

export async function uploadFile(path, fileOrFormData, extraFields = {}) {
  let fd;
  if (fileOrFormData instanceof FormData) {
    // L'appelant a déjà construit son FormData
    fd = fileOrFormData;
  } else {
    fd = new FormData();
    fd.append("file", fileOrFormData);
    Object.entries(extraFields).forEach(([k, v]) => fd.append(k, v));
  }
  const headers = {};
  const token = getToken();
  if (token) headers["Authorization"] = `Bearer ${token}`;
  const res = await fetch(`${API_BASE}${path}`, {
    method: "POST", headers, body: fd, credentials: "include",
  });
  if (!res.ok) {
    const t = await res.text();
    throw new Error(t || res.statusText);
  }
  return res.json();
}

export const api = {
  get: (path) => request("GET", path),
  post: (path, body) => request("POST", path, body),
  put: (path, body) => request("PUT", path, body),
  patch: (path, body) => request("PATCH", path, body),
  del: (path) => request("DELETE", path),
};
